import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import whiteWallet from "../../assets/images/wallet.png";
import blackWallet from "../../assets/images/black-wallet.png";
import greenDot from "../../assets/images/green-dot.png";
import greyDot from "../../assets/images/grey-dot.png";
import fileIcon from "../../assets/images/file-icon.png";
import moneyIcon from "../../assets/images/money-icon.png";
import nechutIcon from "../../assets/images/nechut-icon.png";
import pensionerIcon from "../../assets/images/pensioner-icon.png";
import bookIcon from "../../assets/images/book.png";
import file101Icon from "../../assets/images/file101.png";
import file106Icon from "../../assets/images/file106.png";
import { Button, CircularProgress, MobileStepper, } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import GimlaiCarouselItem from "../GimlaiCarouselItem/GimlaiCarouselItem";
import AmitCarouselItem from "../AmitCarouselItem/AmitCarouselItem";
import UserFund from "../../entities/UserFund";
import { setActiveFund } from "../../state/actions/DashboardActions";
import SalaryData from "../../entities/SalaryData";
import PensionData from "../../entities/PensionData";
import RedemptionRightData from "../../entities/RedemptionRightData";
import DepositData from "../../entities/DepositData";
import { useHistory } from "react-router-dom";
import { setCurrentActiveTab } from "../../state/actions/LettersReportsActions";
import DashboardSidebarProps from "./DashboardSidebarProps";
import "./DashboardSidebar.scss";
import DepositPopUpComponent from "../DepositPopUp/DepositPopUp.component";
import { checkBankAccountPath, CheckBankAccountPathCallVU } from "../../services/CheckBankAccountPath";
import { Get101UrlPath } from "../../services/Get101UrlPath";
import ErrorPopup from "../ErrorPopup/ErrorPopup";
import { checkRedemptionPath } from "../../services/CheckRedemptionPath";
import DepositRequestPopUp from "../DepositPopUp/DepositRequestPopUp.component";
import { GetTofesZikna } from "../../services/TofesZikna";
import { screenSzie } from "../../utils/main";
import useWindowDimensions from "../../customHooks/useWindowDimensions";

const amitimCenterUrl = "https://www.amitim.com/מידע-לעמיתים";


const amitimPesionerUrl = "https://www.amitim.com/%d7%9e%d7%99%d7%93%d7%a2-%d7%9c%d7%a2%d7%9e%d7%99%d7%aa%d7%99%d7%9d/%d7%99%d7%a6%d7%99%d7%90%d7%94-%d7%9c%d7%a4%d7%a0%d7%a1%d7%99%d7%94/";

const amitimDisabilityUrl = "https://www.amitim.com/%d7%9e%d7%99%d7%93%d7%a2-%d7%9c%d7%a2%d7%9e%d7%99%d7%aa%d7%99%d7%9d/%d7%a7%d7%a6%d7%91%d7%aa-%d7%a0%d7%9b%d7%95%d7%aa/";



const DashboardSidebar = (props: DashboardSidebarProps) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const [swiperRef, setSwiperRef] = useState<any>(null);
  const [activeSwiperIndex, setActiveSwiper] = useState<number>(0);
  const { firstName, userFunds, isAmit, isPensioner, userId ,pensionTypeDesc , haveYearlyReportsred , token,is101ButtonAllowed   } = useSelector(
    (state: any) => state.UserReducer
  );
  const {isDoc } = useSelector(
    (state: any) => state.DashboardReducer
  );

  
  const { width } = useWindowDimensions();
  const isTablet = (width < screenSzie.tablet);

  const { activeFund } = useSelector((state: any) => state.DashboardReducer);
  const [interactiveFormPath, setInteractiveFormPath] = useState<any>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showLoadingBank, setShowLoadingBank] = useState<boolean>(false);
  const [showLoadingZikna, setShowLoadingZikna] = useState<boolean>(false);
  const [redemption, setRedemption]  = React.useState(null)
  const [isPensionReceiver, setisPensionReceiver] = useState<boolean>(false);


  const showErrorDeposit = (request: any) => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <DepositPopUpComponent
          interactiveFormPath={request}
          center={true}
          size="m"
          isFromupdateBankAccount={request?.isFromupdateBankAccount != null ? request?.isFromupdateBankAccount : false}
        />
      )
    );
  };

  React.useEffect(() => {
    var count = 0;
    for(var i=0;i<userFunds.length;i++){
        count += userFunds[i].isPensioner ? 1 : 0;    
    }
    setisPensionReceiver(count == 1 ? true : false);
  },[userFunds])

  const showDepositMoney = (request: any) => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <DepositRequestPopUp
          items={request}
          center={true}
          size="m"
        />
      )
    );
  };



  const handleNext = () => {
    if (swiperRef) {
      swiperRef.slideNext();
    }
  };

  const handleBack = () => {
    if (swiperRef) {
      swiperRef.slidePrev();
    }
  };

  const getFundTextIcon = (fund: UserFund) => {
    const { isPensioner, isActiveFund } = fund;

    if (isPensioner) {
      return t("general.kitzva");
    }

    if (isActiveFund) {
      return t("Sidebar.active");
    }
    // amit and not active fund ..
    return t("Sidebar.notActive");
  };

  const getFundIcon = (fund: UserFund) => {
    const { isPensioner, isActiveFund } = fund;    
    if (isPensioner) {
      return (
        <img
          className="sidebar-top-button-icon"
          src={blackWallet}
          width={18}
          height={18}
          alt="black-wallet"
          role="presentation"
          aria-hidden="true" 
        />
      );
    }
  
    if (isActiveFund) {
      return (
        <img
          className="sidebar-top-button-icon"
          src={greenDot}
          width={32}
          height={32}
          alt="green-dot"
          style={{ marginLeft: "-5px" }}
          role="presentation" 
          aria-hidden="true" 
        />
      );
    }
    // amit and not active fund ..
    return (
      <img
        className="sidebar-top-button-icon"
        src={greyDot}
        alt="grey-dot"
        width="35px"
        height="35px"
        style={{ marginLeft: "-5px" }}
        role="presentation"
        aria-hidden="true" 
      />
    );
  };

  const getLastSalaryDataByFundCode = (fundCode: string) => {
    if (props?.userSalaryData?.length) {
      const lastSalaryData = props.userSalaryData.filter(        
        (salary: SalaryData) => salary.fundCode === fundCode
      );     
      if (lastSalaryData.length) return lastSalaryData[0];
    }
    return {} as SalaryData;
  };


  const getPensionDataByFundCode = (fundCode: string) => {
    
    if (props?.userPensionData?.length) {
      const pensionData = props.userPensionData.filter(
        (pension: PensionData) => pension.fundCode === fundCode
      );
      if (pensionData.length) return pensionData[0];
    }
    return {} as PensionData;
  };

  

 
  const getRedemptionRightByFundCode = (fundCode: string) => {
    if (props.redemptionRightData.length) {
      const redemptionData = props.redemptionRightData.filter(
        (redemption: RedemptionRightData) => redemption.fundCode === fundCode
      );
      if (redemptionData.length) return redemptionData[0];
    }
    return {} as RedemptionRightData;
  };

  const getLastDepositByFundCode = (fundCode: string) => {
    if (props?.userDepositData?.length) {
      const lastDeposit = props.userDepositData.filter(
        (deposit: DepositData) => deposit.fundCode === parseInt(fundCode)
      );
      if (lastDeposit.length) return lastDeposit[0];
    }
    return {} as DepositData;
  };

  const openAmitimCenter = () => {
    window.open(amitimCenterUrl);
  };  

  const goToTlushiPension = () => {
    dispatch(setCurrentActiveTab(t("LettersReports.TabLabel2")));
    history.push({
      pathname: '/reports',
      state: {  // location state
          tabVal: t("LettersReports.TabLabel2"), 
      },
    }); 
  };

  const goToReports = () => {
    dispatch(setCurrentActiveTab(t("LettersReports.TabLabel5")));
    history.push({
      pathname: '/reports',
      state: {  // location state
          tabVal: t("LettersReports.TabLabel5"), 
      },
    }); 
  };

  const goToMasConfirms = () => {
    dispatch(setCurrentActiveTab(t("LettersReports.TabLabel6")));
    history.push({
      pathname: '/reports',
      state: {  // location state
          tabVal: t("LettersReports.TabLabel6"), 
      },
    }); 
  };

  const goTo106Docs = () => {
    dispatch(setCurrentActiveTab(t("LettersReports.TabLabel4")));
    history.push({
      pathname: '/reports',
      state: {  // location state
          tabVal: t("LettersReports.TabLabel4"), 
      },
    }); 
  };

  const fill101 = async () => {
    const response = await Get101UrlPath();     
            if (response?.form101Path) {               
                window.open(encodeURI(response?.form101Path), '_blank')
            } else {
              dispatch(setModalState(true));
              dispatch(
                setModalChild(
                  <ErrorPopup size="m" label={t("general.error")} center={true} />
                )
              );             
            }        
  };

  

  const getDepositMoney = async (value: any) => {
    await setShowLoading(true);
    const response = await checkRedemptionPath(0);
    await setShowLoading(false);
    if (response.array_CheckRedemptionPath !== null) {
      const res = await response.array_CheckRedemptionPath.map((item:any)=>{return {
        "calculatedRedemption":item.calculatedRedemption,
        "title":userFunds.filter((userFund:any)=> {return (userFund.fundCode ==  item.fundCode) &&  userFund?.fundLabel}),
        "interactiveFormPath":item.interactiveFormPath,
        "msg":item.msg,
        "fundCode": item.fundCode,
      }})
      return showDepositMoney(res)
    } else {
      return showErrorDeposit(response);
    }
  };

  const getUpdateBankAccount = async (value: any) => {
    await setShowLoadingBank(true);
    const response = await CheckBankAccountPathCallVU(Number(activeFund.fundCode));
    await setInteractiveFormPath(response);
    await setShowLoadingBank(false);
    if (response?.interactiveFormPath) {
      window.open(encodeURI(response?.interactiveFormPath), "_blank");
    } else {
      const newRes = 
      showErrorDeposit({...response, isFromupdateBankAccount: true});
    }
  };
  
  const openPensionerRequest = () => {
    setShowLoadingZikna(true);
    GetTofesZikna(sessionStorage.getItem("fundCode")?.toString()).then((res)=>{
    setShowLoadingZikna(false);
       if(res){
         window.open(res);
       }else {
         dispatch(setModalState(true));
         dispatch(
           setModalChild(
             <ErrorPopup size="m" label={t("Sidebar.ziknaError")} isContactLink={true} subLabel=" " center={true} />
           )
         );          
       }
     })     
  };  

  const openDisabilityRequest = () => {   
    window.open(amitimDisabilityUrl);
  };  


  

  // dont delete it will be use in the future 
  const getpensionTypeDesc = (fundCode: string) => {     
    switch (pensionTypeDesc) {      
        case "קצבת זקנה":
        return t("Dashboard.oldAgePension");
      case "קצבת נכות":
        return t("Dashboard.disabilityPension");
      case "שארי מבוטח":
        return t("Dashboard.shariInsured");
      case "שארי פנסיונר":
        return t("Dashboard.shariInsured");
      default:
        return "";
          }
     };
  return (
    <div
      id="dashboard-sidebar"
      className="dashboard-sidebar"
      //style={{ height: `${isPensioner && !isAmit ? "1200px" : ""}` }}
    >
      
      <div className="sidebar-header-text">
        
        <h2 className="sidebar-title">{`${t(
          "Sidebar.hello"
        )}, ${firstName}`}</h2>
        <span className="sidebar-subtitle">
          { userFunds.length > 1
            ? `${t("Sidebar.youHave")} ${userFunds.length} ${t(
                "Sidebar.funds"
              )}`
            : userFunds.length === 1
            ? t("Sidebar.oneFund")
            : null}
        </span>
      </div>
      <div className="sidebar-top-buttons desktop-da">      
        {userFunds.length &&
          userFunds.map((fund: UserFund, index: number) => (
           
            <button
              id={`sidebar-top-buttons-${index}`}
              onClick={() => dispatch(setActiveFund(fund))}
              key={index}              
              style={{cursor:"pointer"}}
              className={`sidebar-top-button ${
                `${activeFund?.fundLabel} ${activeFund?.fundDesc}` ===
                `${fund?.fundLabel} ${fund?.fundDesc}` && activeFund.isPensioner == fund.isPensioner
                  ? "active-sidebar-button"
                  : ""
              }`}   
              aria-selected={`${activeFund?.fundLabel} ${activeFund?.fundDesc}` ===
              `${fund?.fundLabel} ${fund?.fundDesc}` && activeFund.isPensioner == fund.isPensioner ? true : false}
              role="checkbox"          
            >
              
              <div>
                <div className="sidebar-top-button-text">
                  {localStorage.getItem("lang") === "ar"
                    ? fund?.fundNameArab
                    : fund?.fundLabel}
                </div>
                <div className="small-font">
                { fund.isPensioner ?  props.pensionDesc && props.pensionDesc[fund.fundCode]:`${t("Dashboard.pensionFund")}`}
                </div>          
              </div>
              <div className="sidebar-button-img-wrapper">
                <span
                  className="sidebar-button-icon-text"
                  style={{ marginLeft: `${fund.isPensioner ? "4px" : ""}` }}
                >
                  {getFundTextIcon(fund)}                 
                </span>
                {
               fund.isPensioner ?
                  <img
                  className="sidebar-top-button-icon"
                  src={`${activeFund?.fundLabel} ${activeFund?.fundDesc}` ===
                  `${fund?.fundLabel} ${fund?.fundDesc}` && activeFund.isPensioner == fund.isPensioner ? blackWallet : blackWallet  }
                  width={18}
                  height={18}
                  alt="black-white-wallet"
                  role="presentation"
                  aria-hidden="true" 
                />
                  : 

                  
                  <img
                  className="sidebar-top-button-icon"
                  src={fund?.isActiveFund ? greenDot : greyDot} 
                  width={32}
                  height={32}
                  alt="green-dot"
                  style={{ marginLeft: "-5px" }}
                  role="presentation" 
                  aria-hidden="true" 
                 />
                   }
       
               </div>
            </button>
            // </button>
          ))}
      </div>
      <div className="sidebar-mobile-carousel mobile-da">
        <Swiper
          spaceBetween={-14}
          onSwiper={(swiper: any) => setSwiperRef(swiper) }
          onSlideChange={(swiper: any) => {
            setActiveSwiper(swiper?.realIndex);
            isTablet && dispatch(setActiveFund(userFunds[swiper?.realIndex])) 
          }}
          loop={userFunds?.length > 1}
        >
          {userFunds?.length &&
            userFunds.map((fund: UserFund, index: number) => (
              <SwiperSlide key={index}>
                <div className="mobile-carousel-item mobile-da" key={index}>
                  {fund.isAmit ? (
                    <AmitCarouselItem
                      fund={fund}
                      pensionData={getPensionDataByFundCode(fund.fundCode)}
                      redemptionData={getRedemptionRightByFundCode(
                        fund.fundCode
                      )}
                      lastDeposit={getLastDepositByFundCode(fund.fundCode)}
                    />
                  ) : (
                    <GimlaiCarouselItem
                      fund={fund}
                      lastSalaryData={getLastSalaryDataByFundCode(fund.fundCode)}
                      pensionDesc={props?.pensionDesc}
                    />
                  )}
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {userFunds?.length > 1 ? (
            <MobileStepper
              variant="dots"
              steps={userFunds.length}
              position="static"
              activeStep={activeSwiperIndex}
              sx={{ background: "initial" }}
              nextButton={
                <Button size="small" onClick={handleNext}>
                  <ArrowBackIcon />
                </Button>
              }
              backButton={
                <Button size="small" onClick={handleBack}>
                  <ArrowForwardIcon />
                </Button>
              }
            />
          ) : null}
        </Box>
      </div>
      <div className="dashboard-fast-actions" style={{ marginTop: "26px" }}>
        <h2 className="sidebar-subtitle b-mobile">
          {t("Sidebar.fastActions")}
        </h2>
        <div className="dashboard-fast-actions-buttons">

          {(activeFund.isAmit)  ? (
            <button
              id="dashboard-fast-actions-button-reports"
              className="dashboard-fast-actions-button"
              onClick={goToReports}
              role="link"
            >
              <img
                src={fileIcon}
                alt="file-icon"
                role="presentation"
                aria-hidden="true"
              />
              <span className="sidebar-actions-button-text">
                {t("Sidebar.reports")}
              </span>
            </button>
          ) : null} 

          {activeFund.isPensioner ? (
            <button
              id="dashboard-fast-actions-button-reports"
              className="dashboard-fast-actions-button"
              onClick={goToTlushiPension}
              role="link"
            >
              <img
                src={fileIcon}
                alt="file-icon"
                role="presentation"
                aria-hidden="true"
              />
              <span className="sidebar-actions-button-text">
                {t("Sidebar.tlushiPension")}
              </span>
            </button>
          ) : null} 

          {activeFund.isAmit || (activeFund.isPensioner && (haveYearlyReportsred)) ? (          
              <button
                id="dashboard-fast-actions-button-masConfirms"
                className="dashboard-fast-actions-button"
                onClick={goToMasConfirms}
                role="link"
              >
                <img
                  src={fileIcon}
                  alt="file-icon"
                  width={32}
                  height={32}
                  role="presentation"
                  aria-hidden="true"
                />
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.masConfirms")}
                </span>
              </button>         
          ) : null}
          {isPensionReceiver && !activeFund?.isAmit ?   (          
              <button
                id="dashboard-fast-actions-button-updateBankAccount"
                className="dashboard-fast-actions-button"
                onClick={getUpdateBankAccount}
                role="link"
              >
                <img
                  src={fileIcon}
                  alt="file-icon"
                  width={32}
                  height={32}
                  role="presentation"
                  aria-hidden="true"
                />
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.updateBankAccount")}
                </span>
                <span>&nbsp;&nbsp;</span>                  
                {showLoadingBank ? <CircularProgress size={"1rem"} /> : ""}
              </button>         
          ) : null}
          {activeFund?.isAmit ? (
            <>
              <button
                id="dashboard-fast-actions-button-depositRequest"
                className="dashboard-fast-actions-button"
                onClick={() => {
                  getDepositMoney(interactiveFormPath);
                }}
              >
                <img
                  src={moneyIcon}
                  alt="money-icon"
                  width={32}
                  height={32}
                  role="presentation"
                  aria-hidden="true"
                />
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.depositRequest")}
                  {showLoading ? <CircularProgress size={"1rem"} sx={{marginRight: "5px"}} /> : ""}
                </span>
              </button>

              <button className="dashboard-fast-actions-button"
               onClick={openPensionerRequest}>
                <img src={pensionerIcon} alt="pensioner"/>
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.ziknaRequest")}
                  {showLoadingZikna ? <CircularProgress size={"1rem"} sx={{marginRight: "5px"}} /> : ""}
                </span>
              
              </button>

              <button className="dashboard-fast-actions-button"
              onClick={openDisabilityRequest}>
                <img src={nechutIcon} alt="nechut" />
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.nechutRequest")}
                </span>
              </button> 
             
            </>
          ) : (
            <>                
                {is101ButtonAllowed ?
                             <button
                             id="dashboard-fast-actions-button-fill101"
                             className="dashboard-fast-actions-button"
                                onClick={fill101} title="מעבר לאתר חיצוני">                           
                              <img
                                src={file101Icon}
                                alt="file101Icon"
                                role="presentation"
                                aria-hidden="true"                               
                              />
                              <span className="sidebar-actions-button-text">
                                {t("Sidebar.fill101")}
                              </span>
                            </button>
                               : null}
                  
            
              {activeFund.isPensioner ? (
                <button
                  id="dashboard-fast-actions-button-106Doc"
                  className="dashboard-fast-actions-button"
                  onClick={goTo106Docs}
                  role="link"
                >
                  <img
                    src={file106Icon}
                    alt="file106Icon"
                    role="presentation"
                    aria-hidden="true"
                  />
                  <span className="sidebar-actions-button-text">
                    {t("Sidebar.106Doc")}
                  </span>
                </button>
              ) : null}
             
             

              {/* Part B */}
              {/* <button className="dashboard-fast-actions-button">
                <img src={fileIcon} alt="nechut" />
                <span className="sidebar-actions-button-text">
                  {t("Sidebar.changeBankDeatils")}
                </span>
              </button> */}
            </>
          )}
        </div>
      </div>
      {/* {isAmit ?  (
          <>
            <div className="dashboard-deposit-status">
              <span className="sidebar-subtitle">
                {t("Sidebar.depositStatus")}
              </span>
              <Box sx={{ width: "100%", marginTop: "24px" }}>
                <Stepper
                  activeStep={1}
                  alternativeLabel
                  connector={<ColorlibConnector />}
                >
                  {steps.map((label) => (
                    <Step key={label} sx={{ color: "#77D543" }} color="#77D543">
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </div>
            <div className="dashboard-deposit-status-details">
              <img
                src={statusIcon}
                alt="status"
                role="presentation"
                aria-hidden="true"
              />
              <span className="dashboard-deposit-status-title">
                {t("Sidebar.requestAccepted")}
              </span>
              <span className="dashboard-deposit-status-title">
                {t("Sidebar.statusLabel1")}
              </span>
              <span className="dashboard-deposit-status-text">
                {t("Sidebar.statusLabel2")}
              </span>
              <p className="dashboard-deposit-status-text">
                {t("Sidebar.statusLabel3")}{" "}
                <a
                  href={"mailto:amitimmail@gmail.com"}
                  style={{ cursor: "pointer", color: "black" }}
                >
                  <u>amitimmail@gmail.com</u>
                </a>{" "}
                {t("Sidebar.or")}{" "}
                <u
                  onClick={() => history.push("/contact")}
                  style={{ cursor: "pointer" }}
                  onKeyPress={(event) =>
                    isEnterPress(event) && history.push("/contact")
                  }
                  tabIndex={0}
                >
                  {t("Sidebar.serviceCall")}
                </u>
              </p>
            </div>
          </>
        )
       : null} */}
      {activeFund.isPensioner ? (
        <div className="sidebar-bottom-button-wrapper">
          <button
            id="dashboard-fast-actions-button-kppInfo"
            className="sidebar-bottom-button desktop-da"
            onClick={openAmitimCenter}
            role="link"
          >
            <img
              src={bookIcon}
              alt="book"
              role="presentation"
              aria-hidden="true"
            />
            <span className="sidebar-bottom-button-text">
              {t("Sidebar.kppInfo")}
            </span>
          </button>
        </div>
      ) : (
        <button
          id="dashboard-fast-actions-button-kppInfo"
          className="sidebar-bottom-button desktop-da"
          onClick={openAmitimCenter}
          role="link"
        >
          <img
            src={bookIcon}
            alt="book"
            role="presentation"
            aria-hidden="true"
          />
          <span className="sidebar-bottom-button-text">
            { t("Sidebar.kppInfo")}
          </span>
        </button>
      )}
 { activeFund.isPensioner ? (        
          <button
            id="dashboard-fast-actions-button-kppInfo-mobile"
            className="dashboard-fast-actions-button mobile-da"
            onClick={openAmitimCenter}
            role="link"
          >
            <img
              src={bookIcon}
              alt="book"
              role="presentation"
              aria-hidden="true"
            />
            <span className="sidebar-actions-button-text ">
              {t("Sidebar.kppInfo")}
            </span>
          </button>
       
      ) : (
        <button
          id="dashboard-fast-actions-button-Info-mobile"
          className="dashboard-fast-actions-button mobile-da"
          onClick={openAmitimCenter} 
          role="link"
        >
          <img
            src={bookIcon}
            alt="book"
            role="presentation"
            aria-hidden="true"
          />
          <span className="sidebar-actions-button-text ">
            { t("Sidebar.kppInfo")}
          </span>
        </button>
      )}
    </div>
  );
};

export default DashboardSidebar;
